import { Dispatch, FC, SetStateAction, useState } from "react";
import { Modal } from "../Modal/Modal";
import { ModalBody } from "../Modal/ModalBody";
import { Button, CircularProgress, FormLabel, Grid, Typography } from "@mui/material";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { ApiStatus } from "../../../types/api/status";

interface ModalUploadDocumentProps {
    open: boolean
    rowSelected: any
    status: string
    closeModal :() => void
    onList: () => Promise<void>
    uploadDocument: (id:number, formData: FormData) => Promise<any>
}

export const ModalUploadDocument: FC<ModalUploadDocumentProps> = (props) => {

    const { open, rowSelected, closeModal, onList, status, uploadDocument } = props

    const [file, setFile] = useState<File|null>(null)

    const onSelectFile = (event) => {
        const file = event.target.files[0]
        setFile(file)
    }

    const handleSubmit = async () => {
        if (file === null) return
        
        const formData = new FormData()
        formData.append('document', file)

        const response = await uploadDocument(rowSelected.id, formData)
        if (response === true) {
            closeModal()
            onList()
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick size="sm">
            <ModalBody>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Typography sx={{ fontWeight: 'bolder' }}>
                        SUBIR DOCUMENTO
                    </Typography>
                </Grid>
                <Grid container>
                    <Grid item container sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Grid item xs={4} display="flex" justifyContent="center" alignItems="center">
                            <FormLabel>Seleccione:</FormLabel>
                        </Grid>
                        <Grid item xs={8} mt={2} mb={2}>
                            <Button
                                variant="contained"
                                component="label"
                                style={{ maxWidth: '100%', width: '100%' }}
                                sx={{ boxShadow: 'none', textTransform: 'none', color: '#fff', background: '#212D39', "&:hover": { backgroundColor: "#212D39" } }}
                            >
                                <FileUploadIcon fontSize="small" />
                                {file?.name || ''}
                                <input
                                    style={{ display: 'none' }}
                                    type='file'
                                    name='file'
                                    onChange={onSelectFile}
                                />
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                        <Button
                            onClick={() => handleSubmit()}
                            sx={{ backgroundColor: '#69ABC3', color: '#fff', float: 'right', height: '25px', margin: '0px 5px', padding: '6px 16px', textTransform: 'none', width: 160, "&:hover": { backgroundColor: "#69ABC3" } }}
                        >
                            {
                                status === ApiStatus.FETCHING
                                    ?
                                    <CircularProgress color="inherit" size={20} sx={{ color: '#fff', marginRight: "10px" }} />
                                    :
                                    'Confirmar'
                            }
                        </Button>
                        <Button
                            disabled={status === ApiStatus.FETCHING}
                            onClick={() => closeModal()}
                            sx={{ backgroundColor: '#69ABC3', color: '#fff', float: 'right', height: '25px', margin: '0px 5px', padding: '6px 16px', textTransform: 'none', width: 160, "&:hover": { backgroundColor: "#69ABC3" } }}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                </Grid>
            </ModalBody>
        </Modal>
    )
}